import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import Glossary from '../../images/Glossary (2).png'
function CarbonProgramsInitiatives() {

   const carbonData = [
  {
      title: "Carbon programme:",
      description: "A comprehensive and organized set of activities, projects, and methodologies aimed at achieving greenhouse gas emission reductions or removals within a specific geographic area, sector, or industry"
    },
    {
      title: "Carbon project:",
      description: "An initiative or activity specifically designed to reduce, avoid, or capture greenhouse gas emissions, with the intention of generating carbon credits or contributing to overall climate change mitigation efforts."
    },
    {
      title: "Carbon certification programme:",
      description: "A structured program that certifies and validates the environmental performance of projects, initiatives, or organizations in terms of their greenhouse gas emission reductions or sustainability practices."
    },
    {
      title: "Low-carbon alternatives:",
      description: "Technologies, practices, or processes that generate energy or products with reduced carbon emissions compared to conventional methods. Low-carbon alternatives aim to mitigate the impact of human activities on climate change."
    },
    {
      title: "Carbon offset:",
      description: "A reduction, removal, or avoidance of greenhouse gas emissions to compensate for emissions occurring elsewhere. Carbon offsets are often used as a strategy to achieve carbon neutrality."
    }
  ];


  const CarbonItem = ({ title, description }) => {
  return (
    <div className="flex flex-col items-start p-0 gap-4 w-full max-w-[1152px]">
      <h3 className="text-[24px] font-medium text-2xl leading-[29px] text-[#141414]">
        {title}
      </h3>
      <p className="w-full  font-normal text-[16px] leading-[150%] text-[#141414]">
        {description}
      </p>
    </div>
  );
};
  return (
    <>
    <Header/>
    <div className="relative w-full max-w-[1440px] h-[933px] top-[0px] mx-auto">
      {/* Text Section */}
      <div className="absolute w-full max-w-[1200px] h-[76px] left-1/2 transform -translate-x-1/2 top-[82px] flex flex-col items-center p-0 gap-10">
        <h1 className="w-full max-w-[688px] h-[76px] font-medium text-6xl leading-[76px] text-center text-[#141414]">
          Carbon Programs & Initiatives
        </h1>
      </div>

      {/* Image Section */}
      <img 
        className="absolute w-full max-w-[1200px] h-[552px] left-1/2 transform -translate-x-1/2 top-[275px] rounded-2xl  object-cover"
        src={Glossary}
        alt="Carbon Incentive"
      />
    </div>


 <div className="w-full max-w-[1200px] mx-auto mt-20 mb-20 flex flex-col items-start gap-8">
      <h2 className=" font-bold text-[32px] leading-[38px] text-[#0D924F]">
          Carbon Programs & Initiatives
      </h2>
      <div className="flex flex-col gap-6 w-full">
        {carbonData.map((item, index) => (
          <CarbonItem 
            key={index}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
    <Footer/>
    </>



  )
}

export default CarbonProgramsInitiatives



